import { Injectable } from '@angular/core';
import { MatStepperIntl } from '@angular/material/stepper';

@Injectable()
export class StepperIntl extends MatStepperIntl {
  override optionalLabel = 'Opcional';
}
